import { render, staticRenderFns } from "./BotaoBaixarTodos.vue?vue&type=template&id=7d4a413c&scoped=true"
import script from "./BotaoBaixarTodos.vue?vue&type=script&lang=js"
export * from "./BotaoBaixarTodos.vue?vue&type=script&lang=js"
import style0 from "./BotaoBaixarTodos.vue?vue&type=style&index=0&id=7d4a413c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a413c",
  null
  
)

export default component.exports